export default __webpack_public_path__ + "static/media/us-flag.2ddc1615.svg";